import { Button } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import './RoleCarousel.scss';

type RoleCarouselProps = {
  currentIndex: number;
  totalRoles: number;
  onPrevious: () => void;
  onNext: () => void;
  roleTypeLabel?: string;
};

export const RoleCarousel = ({
  currentIndex,
  totalRoles,
  onPrevious,
  onNext,
  roleTypeLabel = 'Role',
}: RoleCarouselProps) => {
  if (totalRoles <= 1) {
    return null;
  }

  const canNavigatePrev = currentIndex > 0;
  const canNavigateNext = currentIndex < totalRoles - 1;

  return (
    <div className="roleCarousel">
      <Button
        icon={IconNames.CHEVRON_LEFT}
        minimal
        small
        disabled={!canNavigatePrev}
        onClick={onPrevious}
        title="Previous role"
      />

      <span className="roleCarousel__counter">
        {roleTypeLabel} {currentIndex + 1} of {totalRoles}
      </span>

      <Button
        icon={IconNames.CHEVRON_RIGHT}
        minimal
        small
        disabled={!canNavigateNext}
        onClick={onNext}
        title="Next role"
      />
    </div>
  );
};
